export const CHAT_LAUNCHER_HIDDEN_CLASS = 'chat-launcher-hidden';

/** Hides the HubSpot chat launcher, e.g. where it would cover bottom-right actions. Styled in the app's global styles. */
export const setChatLauncherHidden = (isHidden: boolean): void => {
  console.log(`[HubSpot] chat launcher ${isHidden ? 'hidden' : 'shown'} by the current page`);
  document.body.classList.toggle(CHAT_LAUNCHER_HIDDEN_CLASS, isHidden);
};
